'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');
const Events = require('constants/Events');
// const Constants = require('constants/Constants');

const Funding = require('components/Index/IndexFeatures/Blocks/Funding/Funding.js');
const Cards = require('components/Index/IndexFeatures/Blocks/Cards/Cards.js');
const Widgets = require('components/Index/IndexFeatures/Blocks/Widgets/Widgets.js');
const Controls = require('components/Index/IndexFeatures/Blocks/Controls/Controls.js');

require('owl.carousel/src/scss/_core.scss');
require('owl.carousel/src/scss/_animate.scss');
require('owl.carousel');
require('./IndexFeatures.less');

const Selectors = {
    el: '.IndexFeatures',
    wrapperSequence: '.IndexFeatures-sequences-wrapper',
    blockText: '.IndexFeatures-about p',
    title: '.IndexFeatures-list-title',
    description: '.IndexFeatures-list-description'
};

const BindFunctions = [
    'onResize',
    'activateSectionShown'
];

const ChildViews = {
    'IndexFeatures-Funding': {
        selector: '.IndexFeatures-Funding',
        viewConstructor: Funding
    },
    'IndexFeatures-Controls': {
        selector: '.IndexFeatures-Controls',
        viewConstructor: Controls
    },
    'IndexFeatures-Widgets': {
        selector: '.IndexFeatures-Widgets',
        viewConstructor: Widgets
    },
    'IndexFeatures-Cards': {
        selector: '.IndexFeatures-Cards',
        viewConstructor: Cards
    }
};

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);
        this.options = options;
        this.isCarouselActive = false;

        setTimeout(() => {
            app.vent.on(Events.common.resize, this.onResize);
            app.vent.on(Events.home.hero.sequenceEnded, this.onResize);
            this.onResize();

            this.viewsRegistration(ChildViews);
            this.cards = [
                this.views['IndexFeatures-Funding'],
                this.views['IndexFeatures-Controls'],
                this.views['IndexFeatures-Widgets'],
                this.views['IndexFeatures-Cards']
            ];
        }, 20);

        setTimeout(() => {
            this.objsLine = [];

            _.each(this.$(Selectors.blockText), (item) => {
                const obj = {
                    $container: $(item),
                    className: 'IndexFeatures-aboutLine',
                    autoWidth: true
                };

                this.objsLine.push(obj);
                app.utils.splitMultilineToSeparateSpans(obj);
            });

            this.titleObj = {
                $container: this.$(Selectors.title),
                className: 'IndexFeatures-list-titleLine',
                autoWidth: true
            };
            app.utils.splitMultilineToSeparateSpans(this.titleObj);

            this.descrObj = {
                $container: this.$(Selectors.description),
                className: 'IndexFeatures-list-descriptionLine',
                autoWidth: true
            };
            app.utils.splitMultilineToSeparateSpans(this.descrObj);
        }, 1000);
    },


    activateSectionShown: function ($el) {
        if (!!$el) {
            if ($el.is(this.$(Selectors.wrapperSequence))) {
                _.invoke(this.cards, 'onShow');
            }

            if ($el.is(this.$(Selectors.blockText))) {
                _.each(this.$(Selectors.blockText), (item, id) => {
                    if ($el[0] === item) {
                        app.utils.animateTextByLines(this.objsLine[id], {
                            lineDuration: 1000,
                            lineDelay: 30,
                            shift: 30
                        });
                    }
                });
            } else if ($el.is(this.$(Selectors.title))) {
                app.utils.animateTextByLines(this.titleObj, {
                    lineDuration: 1000,
                    lineDelay: 30,
                    shift: 30
                });
            } else if ($el.is(this.$(Selectors.description))) {
                app.utils.animateTextByLines(this.descrObj, {
                    lineDuration: 1000,
                    lineDelay: 30,
                    shift: 30
                });
            }
        }
    },

    onResize: function () {
        if (window.matchMedia('(min-width: 768px)').matches) {
            this.toggleCarousel(false);
        } else {
            this.toggleCarousel(true);
        }
    },


    toggleCarousel: function (isActive) {
        if (isActive === this.isCarouselActive) {
            return;
        }

        if (isActive) {
            this.$('.IndexFeatures-sequences-aspect')
                .addClass('owl-carousel owl-theme')
                .owlCarousel({
                    stagePadding: 0,
                    items: 1,
                    margin: 0,
                    singleItem: true,
                    loop: false,
                    dots: true
                });

            this.$('.IndexFeatures-sequences-aspect').on('changed.owl.carousel', function (e) {
                if (e.item.index === null) {
                    return;
                }
                this.cards[e.item.index].onActive();
            }.bind(this));
        } else {
            this.$('.IndexFeatures-sequences-aspect')
                .owlCarousel('destroy')
                .removeClass('owl-carousel owl-theme');
        }

        this.isCarouselActive = isActive;
    }

});
